import { connect } from 'react-redux';
import historyUtils from 'utils/history';
import locator from 'utils/locator';
import AddressFormModalRouted from 'components/Address/common/AddressFormModalRouted/AddressFormModalRouted';
import { onCloseAddEditModal } from 'redux/modules/address/actions';
import { resetAddressSuggestion } from 'redux/modules/address-suggestion/actions';
import { getRoutedAddressModalFormProps } from 'redux/modules/address/selectors';
import { withRouteProps } from 'utils/with-route-props';

const mapStateToProps = (state, props) => {
  const { history } = props;
  const { location = {} } = history;
  const { hash = '' } = location;
  return {
    ...getRoutedAddressModalFormProps(state, hash),
  };
};

const mapDispatchToProps = dispatch => ({
  onCloseModal: async address => {
    await dispatch(onCloseAddEditModal(address));
    return dispatch(resetAddressSuggestion());
  },
  clearNavigationAction: () => {
    dispatch(resetAddressSuggestion());
    historyUtils.replace(`${locator.pathname.split('#')[0]}${locator.search}`);
  },
});

export default withRouteProps(connect(mapStateToProps, mapDispatchToProps)(AddressFormModalRouted));
